import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export type State = {
  theme: 'reddish' | 'pinkish' | undefined;
};

interface UseTheme extends State {
  setTheme: (state: Partial<UseTheme>) => void;
}

const initialState: State = {
  theme: undefined,
};

export const useTheme = create<UseTheme>()(
  devtools(set => ({
    ...initialState,
    setTheme: args => set({ ...args }),
  })),
);
